import type { ViewQueryList, ViewQueryRecordNodeWithId, ViewQueryRecordNodeWithParent } from '@salescore/core'

import type { RSheetColumn, RSheetRecordNode } from '../../domain/column'
import { getDefaultAttributes } from '../../recoil/records/selectors/querySelector'
import { getActiveConditionalEffects } from './conditionalEffects'

/**
 * 「書き込み禁止」のセルでは、クリック/キーボード操作でレコード作成 (→ チェック) をさせない
 * - 書き込み禁止は列全体 (readonly) のことも条件付きのこともあり、条件付きのときはこれから作られる新規レコードの内容で判定して、
 * クリックで作成した直後にそのセルが書き込み禁止になるかどうかと結果をそろえる
 * - 判定に使うのは record node の型に依存しない 3 フィールドのみなので、呼出側の列型 (RSheetColumn / SheetColumn) を問わず受けられるよう Pick で受ける
 */
export const isCellWriteProhibited = (
  column: Pick<RSheetColumn<RSheetRecordNode>, 'readonly' | 'node' | 'conditionalEffects'>,
  parentRecordNode: ViewQueryRecordNodeWithId,
  query: ViewQueryList | undefined,
): boolean => {
  if (column.readonly === true) {
    return true
  }
  const { recordAttributes } = getDefaultAttributes(column.node, query)
  const newRecordNode: ViewQueryRecordNodeWithParent = {
    id: undefined,
    attributes: recordAttributes,
    meta: { height: 1, innerRowIndexStart: 0, innerRowIndexEnd: 1 },
    children: [],
    parent: parentRecordNode,
  }
  return getActiveConditionalEffects(column.conditionalEffects, newRecordNode, {}).some(
    (effect) => effect.effect === 'disable',
  )
}
